import React, { createContext, useContext, useState } from 'react';

const EpisodeContext = createContext();

export const EpisodeProvider = ({ children }) => {
    const [episode, setEpisode] = useState(null);

    const updateEpisode = (episodeDetails) => {
        setEpisode(episodeDetails);
    };

    return (
        <EpisodeContext.Provider value={{ episode, updateEpisode }}>
            {children}
        </EpisodeContext.Provider>
    );
};

export const useEpisode = () => useContext(EpisodeContext);
